<template>
<div class="flex-column">
    <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
            <b-form-group label="Sales Order #" class="mr-2" v-if="isSalesOrdersFilter">
                <b-form-input v-model="filters.soNumber"  @input="onSearch" size="sm" />
            </b-form-group>
            <b-form-group label="Purchase Order #" class="mr-2" v-else>
                <b-form-input v-model="filters.poNumber"  @input="onSearch" size="sm" />
            </b-form-group>
            <b-form-group label="Part #" class="mr-2">
                <b-form-input v-model="filters.partNumber"  @input="onSearch" size="sm" />
            </b-form-group>
            <b-form-group label="Company" class="mr-2">
                <b-form-input v-model="filters.companyName"  @input="onSearch" size="sm" />
            </b-form-group>
            <b-form-group label="As Of" class="mr-2" v-if="!isPastDue">
                <date-picker v-model="filters.asOfDate" :config="datePickerOptions" @input="onSearch"></date-picker>
                <!-- <input type="date" v-model="filters.asOfDate" @input="onSearch" size="sm" /> -->
            </b-form-group>

        </div>
    </div>
</div>
</template>

<script>
import { debounce } from 'lodash';
import { DATE_FORMAT } from '@/shared/constants';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
    components: {
    },
    props: {
        isSalesOrdersFilter: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Object,
            default: () => {}
        },
        title: {
            type: String,
            default: ""
        },
        keyNdx: {
            type: Number,
            default: 0
        },
        isPastDue: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            datePickerOptions: {
                format: DATE_FORMAT,
                useCurrent: false,
            },
        }
    },
    methods: {
        onSearch: debounce(function () {
            this.$emit('onSearch', this.keyNdx);
		}, SEARCH_DEBOUNCE_TIME),
    }
}
</script>